"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateVendor = exports.useCreateVendor = exports.useVendorFetch = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const vendorAction_1 = require("./vendorAction");
const useVendorFetch = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchVendorLoading = (0, react_redux_1.useSelector)((State) => State["vendor/fetch"].loading);
    const fetchVendorError = (0, react_redux_1.useSelector)((State) => State["vendor/fetch"].error);
    const fetchVendorData = (0, react_redux_1.useSelector)((State) => State["vendor/fetch"].data);
    const fetchVendor = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!isUserLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, vendorAction_1.fetch)(payload));
    });
    return {
        fetchVendorLoading,
        fetchVendorError,
        fetchVendorData,
        fetchVendor
    };
};
exports.useVendorFetch = useVendorFetch;
const useCreateVendor = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createVendorLoading = (0, react_redux_1.useSelector)((State) => State["vendor/create"].loading);
    const createVendorError = (0, react_redux_1.useSelector)((State) => State["vendor/create"].error);
    const createVendor = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, vendorAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in creating vendor");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createVendorLoading,
        createVendorError,
        createVendor
    };
};
exports.useCreateVendor = useCreateVendor;
const useUpdateVendor = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updateVendorLoading = (0, react_redux_1.useSelector)((State) => State["vendor/update"].loading);
    const updateVendorError = (0, react_redux_1.useSelector)((State) => State["vendor/update"].error);
    const updateVendor = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, vendorAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in updating vendor");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateVendorLoading,
        updateVendorError,
        updateVendor
    };
};
exports.useUpdateVendor = useUpdateVendor;
